import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

import RFQIntro from 'apps/rfq/rfqPage/views/rfqIntro';
import DetailsBlock from 'apps/rfq/rfqPage/views/detailsBlock';
import NeedPerfectQuote from 'apps/rfq/rfqPage/views/needPerfectQuote';

import { useViewerControl } from 'libs/rendering/gltf/hooks';

import { ShipmentQuotes } from '../../ShipmentQuotes';
import { IntermediatorRFQProductQuotes } from './IntermediatorRFQProductQuotes';
import { RFQIssues } from './RFQIssues';
import { DFMIssues } from './DFMIssues';

const IntermediatorRFQPage = observer(props => {
  const viewerControl = useViewerControl();

  const { rfqManager } = props;
  const { rfqApp } = rfqManager;
  // const { quoteFormStore } = quotesManager;
  // const quoteFormRef = useRef(null);
  // const forwardedQuotesRef = useRef(null);
  // useEffect(() => {
  //   quotesManager.forwardedQuotesRef = forwardedQuotesRef;
  // }, [forwardedQuotesRef]);

  // get the analyzed body and fabrication process from build
  const { cadId } = rfqApp?.jobSpec?.build;
  let body = cadId && viewerControl.cadFile?.assembly?.GetBodyById(cadId);
  if (!body && viewerControl.cadFile) {
    // HACK: get the part from the camera instance...
    const instance = viewerControl.currentInstance;
    if (instance) {
      body = instance.GetBody();
    }
  }

  /*
    effects
  */

  return (
    <>
      <RFQIntro rfqManager={rfqManager} rfqApp={rfqApp} isIntermediator />
      <DFMIssues rfqApp={rfqApp} body={body} />
      <RFQIssues rfqManager={rfqManager} />
      <NeedPerfectQuote rfqManager={rfqManager} />
      <DetailsBlock rfqManager={rfqManager} jobSpec={rfqApp.jobSpec} />
      {/* <RFQAssigner rfqManager={rfqManager} /> */}
      <ShipmentQuotes
        rfqId={rfqApp.id}
        shipmentQuotes={rfqApp.shipmentQuotes.apps}
      />
      <IntermediatorRFQProductQuotes rfqApp={rfqApp} />
    </>
  );
});

IntermediatorRFQPage.propTypes = {
  rfqManager: PropTypes.object,
  quotesManager: PropTypes.object,
};

export default withNamespaces()(IntermediatorRFQPage);
